<template>
   <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="mb-4">Url</h1>
          <div class="code-container">
              <code id="codeblock" class="px-3 pt-4">
                <div v-if="copied" id="animated-example" class="animated-copied fadeOut theme-main-color caption">
                  Copied
                  <v-icon class="white--text caption">mdi-check</v-icon>
                </div>
                <div class="pb-4 url-wrapper">
                  {{ url }}
                </div>
                <button
                  type="button"
                  v-clipboard:copy="url"
                  v-clipboard:success="onCopy"
                  class="copy-code">Copy</button>
              </code>
          </div>
        </v-col>
      </v-row>
   </v-container>
</template>

<script>
import {
  buildUrl, formatOptions, initialTheme, getCleanConfigs, getCleanThemes, getAttributesAsObject
} from '@/utils/helpers'
import { initialConfig } from '@/utils/initialConfig'
import { mapState } from 'vuex'

export default {
  name: 'Url',
  data: () => ({
    url: null,
    copied: false
  }),
  computed: {
    ...mapState({
      config: ({ context }) => context.config,
      attributes: ({ context }) => context.attributes,
      userAttributes: ({ context }) => context.userAttributes,
      theme: ({ theme }) => theme.theme,
      cashierVersion: ({ context }) => context.cashierVersion
    })
  },
  methods: {
    onCopy (e) {
      console.log(e.text)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    }
  },
  created () {
    const cleanConfigs = getCleanConfigs(initialConfig, this.config)
    const cleanTheme = getCleanThemes(initialTheme, this.theme)
    const cashierVersion = this.cashierVersion || 'develop'
    const attributes = (this.attributes) && getAttributesAsObject(this.attributes, this.userAttributes ?? '').attributes
    const userAttributes = this.userAttributes && getAttributesAsObject(this.attributes ?? '', this.userAttributes).user

    const config = {
      environment: 'test',
      ...cleanConfigs,
      theme: {
        ...cleanTheme
      }
    }
    if (attributes) {
      config.attributes = attributes
    }
    if (userAttributes) {
      config.user = userAttributes
    }
    const url = `https://checkout.paymentiq.io/cashier/${cashierVersion}/?${buildUrl(formatOptions(config))}`
    this.url = url
    console.log(url)
  }
}
</script>

<style lang="scss" scoped>
#codeblock {
  display: block;
  min-width: 500px !important;
  max-width: 100%;

  .url-wrapper {
    overflow-wrap: break-word;
  }
}
</style>
